import { styled } from '@linaria/react';
import { fonts, semantic, size, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-500']};
  padding: ${space['space-600']};
  background: ${semantic.bg.surfaceSubtle};
  border: ${size.stroke['stroke-default']} solid ${semantic.border.primary};
  border-radius: ${size.radius['radius-md']};
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
  flex: 1;
  min-width: 0;
`;

export const Title = styled.p`
  font-family: ${fonts.body};
  font-weight: ${fonts.weight.medium};
  font-size: ${fonts.size.base};
  color: ${semantic.text.primary};
  margin: 0;
`;

export const Subtitle = styled.div`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  color: ${semantic.text.primary};
  margin: 0;
`;

export const CtaWrapper = styled.div`
  flex-shrink: 0;
`;
